export const PAGE_SIZE = 24
export const FIRST_PAGE_SIZE = 3
export const COLLAPSED_VIEW_POWTOON_SIZE = 3
export const DOCUMENT_NAME_MAX_CHARACTERS = 45